// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__321tr","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3Ez5N"};